/**
 * @file NotFound.js — Page d'erreur 404 (page non trouvée).
 * Affichée lorsque l'URL ne correspond à aucune route définie (R-0124).
 * Propose des suggestions et un lien vers la page d'accueil.
 */
import { Link, useLocation } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useTranslation } from 'react-i18next';
import { APP_ROUTES } from '../lib/routes';

/**
 * Page d'erreur 404 avec code d'erreur, message explicite, URL fautive et suggestions.
 * @returns {React.ReactElement}
 */
export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground px-4" data-testid="error-404-page">
      <FileQuestion className="h-12 w-12 text-muted-foreground mb-4" />
      <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>{t('errors.404_title')}</h1>
      <p className="text-lg text-muted-foreground mb-1">{t('errors.404_heading')}</p>
      <p className="text-sm text-muted-foreground mb-4 text-center max-w-md">
        {t('errors.404_message')}
      </p>
      <p className="text-xs text-muted-foreground mb-1">
        {t('errors.404_url_label')}: <code className="px-1 py-0.5 bg-muted rounded">{location.pathname}</code>
      </p>
      <p className="text-xs text-muted-foreground mb-6">
        {t('errors.error_code_label')}: <code className="px-1 py-0.5 bg-muted rounded">{t('errors.404_code')}</code>
      </p>
      <div className="flex gap-3">
        <Button asChild>
          <Link to={APP_ROUTES.home}>{t('errors.go_home')}</Link>
        </Button>
        <Button asChild variant="outline">
          <Link to={APP_ROUTES.login}>{t('errors.go_login')}</Link>
        </Button>
      </div>
    </div>
  );
}
